import { render } from "./LegalContentView.vue?vue&type=template&id=373051a2&scoped=true"
import script from "./LegalContentView.vue?vue&type=script&lang=js"
export * from "./LegalContentView.vue?vue&type=script&lang=js"

import "./LegalContentView.vue?vue&type=style&index=0&id=373051a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373051a2"]])

export default __exports__